export const SlaStatusIdsEnum = {
  0: 'AwaitingInventoryAllocation',
  1: 'AwaitingReset',
  2: 'Unavailable',
  3: 'PendingOnTime',
  4: 'FulfilledOnTime',
  5: 'PendingLate',
  6: 'FulfilledLate'
}

export const SlaStatusEnum = {
  AwaitingInventoryAllocation: 'AwaitingInventoryAllocation',
  AwaitingReset: 'AwaitingReset',
  Unavailable: 'Unavailable',
  PendingOnTime: 'PendingOnTime',
  FulfilledOnTime: 'FulfilledOnTime',
  PendingLate: 'PendingLate',
  FulfilledLate: 'FulfilledLate'
}

export const SlaBadgeEnum = {
  [SlaStatusEnum.AwaitingInventoryAllocation]: 'time-unavailable',
  [SlaStatusEnum.AwaitingReset]: 'time-unavailable',
  [SlaStatusEnum.Unavailable]: 'time-unavailable',
  [SlaStatusEnum.PendingOnTime]: 'pending',
  [SlaStatusEnum.FulfilledOnTime]: 'on-time',
  [SlaStatusEnum.PendingLate]: 'late',
  [SlaStatusEnum.FulfilledLate]: 'late'
}
